import React, { useState } from 'react';

const CreateUserProfile = ({ onCreateProfile }) => {
  const [profileData, setProfileData] = useState({
    username: '',
    email: '',
    // Add other profile fields as necessary
  });

  const handleChange = (e) => {
    setProfileData({
      ...profileData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Call onCreateProfile, which should be a function to interact with your backend
    onCreateProfile(profileData);
  };

  return (
    <form className="kb-form" onSubmit={handleSubmit}>
      <input
        type="text"
        name="username"
        value={profileData.username}
        onChange={handleChange}
        placeholder="Username"
        required
      />
      <input
        type="email"
        name="email"
        value={profileData.email}
        onChange={handleChange}
        placeholder="Email"
        required
      />
      {/* Add other input fields as necessary */}
      <button type="submit">Create Profile</button>
    </form>
  );
};

export default CreateUserProfile;
